import React from 'react';
import { exit_icon } from '../icons/exit';
import { MultiSelect } from './multiSelect';
import {motion} from 'framer-motion'

const FillterModal = ({
  categories,
  crop,
  setCrop,
  states,
  state,
  setState,
  setShowFilters,
  onSubmit,
  name
}) => {
  return (
    <>
      <motion.div
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0, transition: { duration: 0.1 } }}
        transition={{ duration: 0.2 }}
        className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none"
      >
        <div className="relative max-w-3xl w-[350px] mx-auto my-6">
          <div className="relative flex flex-col w-full bg-white border-[3px] border-primary rounded-3xl shadow-lg outline-none focus:outline-none h-[290px] p-3">
            <div
              className="text-red-600 w-8"
              onClick={() => setShowFilters(false)}
            >
              {exit_icon}
            </div>
            <div className="flex flex-col gap-5 h-full justify-center items-center">
              <p className="text-gray-400 font-bold text-lg">تخصيص البحث</p>
              <div className="w-full">
                <MultiSelect
                  options={categories.map((e) => {
                    return { label: e.name, value: e.id };
                  })}
                  value={crop}
                  onChange={setCrop}
                  placeHolder={name}
                />
              </div>
              <div className="w-full">
                <MultiSelect
                  options={states.map((e) => {
                    return { label: e.name, value: e.id };
                  })}
                  value={state}
                  onChange={setState}
                  placeHolder="المنطقة"
                />
              </div>
              <div
                className="w-28 h-10 bg-primary rounded-xl text-white font-bold flex justify-center items-center"
                onClick={() => (onSubmit(), setShowFilters(false))}
              >
                موافق
              </div>
            </div>
          </div>
        </div>
      </motion.div>
      <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
    </>
  );
};

export default FillterModal